export default __webpack_public_path__ + "static/media/shakinghands.ef0aa97a.jpg";